export const downloadPath = "<path d=\"M8 2.5 V10 M5 7 L8 10 L11 7 M3.5 13 H12.5\" fill=\"none\" stroke=\"currentColor\" stroke-width=\"1.5\" stroke-linecap=\"round\" stroke-linejoin=\"round\"/>"
